'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { usePostHog } from 'posthog-js/react'
import { GET_USER_PROFILE } from '../user/profile/queries'
import { Query } from '@/lib/generated/graphql-types'
import { useSuspenseQuery } from '@apollo/client'

export function PostHogPageView(): null {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const posthog = usePostHog()

  useEffect(() => {
    // Track pageviews
    if (pathname && posthog) {
      let url = window.origin + pathname
      if (searchParams.toString()) {
        url = url + `?${searchParams.toString()}`
      }
      posthog.capture('$pageview', {
        $current_url: url,
      })
    }
  }, [pathname, searchParams, posthog])

  return null
}

export function PostHogAuthenticate({
  email,
  isAuthenticated,
}: {
  email: string | undefined | null
  isAuthenticated: boolean
}): null {
  const posthog = usePostHog()

  const { data: userProfileData } = useSuspenseQuery<
    Pick<Query, 'getUserProfile'>
  >(GET_USER_PROFILE, {
    skip: !isAuthenticated,
  })
  const userId = userProfileData?.getUserProfile?.userId
  useEffect(() => {
    if (email && userId && posthog) {
      posthog.identify(userId, { email })
    }
  }, [email, posthog, userId])

  return null
}
